import httpClient from "Api/httpClient";

const END_POINT = "/nonconformance";

const printNonconformance = (nonconformance_id) => {
    if (!nonconformance_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + nonconformance_id + "/print_tag";
    return httpClient.get(SINGLE_END_POINT);
};

export { printNonconformance };
